/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('AppServiceApi', ($http, ApiErrorService) => {
    return {
        settings: settings,
        getAllConfigurations: getAllConfigurations,
        updateConfiguration: updateConfiguration,
        idleInfo: idleInfo,
        passwordRules: passwordRules,
        systemInfo: systemInfo
    };
    function settings() {
        return $http.get(`api/App/Settings`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllConfigurations() {
        return $http.get(`api/App/GetAllConfigurations`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function updateConfiguration(config) {
        return $http.post(`api/App/UpdateConfiguration`, config)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function idleInfo() {
        return $http.get(`api/App/IdleInfo`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function passwordRules() {
        return $http.get(`api/App/PasswordRules`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function systemInfo() {
        return $http.get(`api/App/SystemInfo`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
